var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Observable } from "rxjs";
import { take } from "rxjs/operators";
import { Subject } from "rxjs";
import { State } from "./State";
var InputState = /** @class */ (function (_super) {
    __extends(InputState, _super);
    function InputState(initialValue) {
        var _this = this;
        var isNonValue = function (val) {
            return val === undefined;
        };
        var afterConnect = function (state, setStateFn) {
            setStateFn(initialValue);
        };
        var afterDisConnect = function (state, setStateFn) {
            if (state.hasValue()) {
                setStateFn(undefined);
            }
        };
        var state = new Subject();
        _this = _super.call(this, state, isNonValue, afterConnect, afterDisConnect) || this;
        _this.state = state;
        _this.timestampOfLastPromise = -1;
        return _this;
    }
    InputState.prototype.putValue = function (val, reason) {
        this.state.next(val);
        return this;
    };
    InputState.prototype.clearAndPutFromPromise = function (promise) {
        var _this = this;
        if (this.hasValue()) {
            this.clear();
        }
        this.timestampOfLastPromise = Date.now();
        promise.then(
        // success
        function (value) {
            _this.timestampOfLastPromise = -1;
            _this.putValue(value);
        }, 
        // error
        function () {
            _this.timestampOfLastPromise = -1;
            _this.clear();
        });
        return this;
    };
    InputState.prototype.isPristine = function () {
        return !this.hasValue() && !this.hasActivePromiseRequest();
    };
    InputState.prototype.hasActivePromiseRequest = function () {
        return this.timestampOfLastPromise !== -1;
    };
    InputState.prototype.isPromiseRequestOlderThan = function (timeoutInMs) {
        var ageValue = Date.now() - this.timestampOfLastPromise;
        return ageValue > timeoutInMs;
    };
    InputState.prototype.putFromPromiseIfPristine = function (calledIfPristine) {
        if (this.isPristine()) {
            this.clearAndPutFromPromise(calledIfPristine());
        }
        return this;
    };
    InputState.prototype.clear = function (reason) {
        this.putValue(undefined);
        return this;
    };
    InputState.prototype.doModify = function (valueMapper, or) {
        var _this = this;
        if (this.hasValue()) {
            this.values$().pipe(take(1)).subscribe(function (oldVal) {
                var newInput = valueMapper(oldVal);
                if (newInput instanceof Observable) {
                    newInput.pipe(take(1)).subscribe(function (newVal) {
                        _this.putValue(newVal);
                    });
                }
                else {
                    _this.putValue(newInput);
                }
            });
        }
        else {
            var orInput = or();
            if (orInput instanceof Observable) {
                orInput.pipe(take(1)).subscribe(function (newVal) {
                    _this.putValue(newVal);
                });
            }
            else {
                this.putValue(orInput);
            }
        }
        return this;
    };
    return InputState;
}(State));
export { InputState };
export function input(initValue) {
    if (initValue === void 0) { initValue = undefined; }
    return new InputState(initValue);
}
